import React from 'react'

const useConfig = () => {
    const clientID =
    "&client_id=dts4oYlpU3WeX1vV3VqKbx13d25G5LAZ0uzt9L6CDXc"
    return {clientID}
}

export default useConfig